import { ApiSet, BaseResponse, IndexApiSet, useDeleteApi, useIndexApi } from 'utils/network/api_hooks'
import { CraifHttpClient } from '../utils/network/axios'
import { RequestForm } from 'entities/request_form'
import { PagingResponse } from 'entities'
import { UserSearchForm } from 'components/user_search/user_search_page'
import { Form } from 'utils/hooks'

type ResultRequestForm = RequestForm & {
    pcrRunIds?: number[]
}

type UserSearchResponse = PagingResponse & {
    results: ResultRequestForm[]
}
export function useSearchUserApi(searchForm: Form<UserSearchForm>): IndexApiSet<UserSearchResponse> & { execute: () => void } {
    const apiPath = 'user_search/'
    const api = useIndexApi<UserSearchResponse>(new CraifHttpClient(), {
        initialResponse: { count: 0, results: [] },
    })

    const execute = (): void => {
        api.execute(apiPath, { params: searchForm.object })
    }

    return { ...api, execute: execute }
}

type CancelExamResponse = BaseResponse
export function useCancelExamApi(): ApiSet<CancelExamResponse> & { execute: (requestForm: number) => void } {
    const api = useDeleteApi<CancelExamResponse>(new CraifHttpClient(), {
        initialResponse: {},
    })

    const execute = (requestFormId: number): void => {
        api.execute(`user_search/${requestFormId}/`)
    }

    return { ...api, execute: execute }
}
